export const tag = (value: any): true => true;

export default tag;
